import Account from './contexts/AccountContext';
import App from './contexts/AppContext';
import Widgets from './contexts/WidgetsContext';
import Modal from './contexts/ModalContext';
import Plans from './contexts/PlansContext';

export const isDemo = process.env.REACT_APP_DEMO_MODE === 'true';
export const isLocal = process.env.REACT_APP_LOCAL_MODE === 'true';
export const isLocalServer = process.env.REACT_APP_LOCALSERVER_MODE === 'true';

const REGISTERED_CONTEXTS = [Modal, Widgets, Plans, App, Account];

const GlobalContex = {
  ModalContext: Modal.context,
  WidgetsContext: Widgets.context,
  PlansContext: Plans.context,
  AppContext: App.context,
  AccountContext: Account.context
};

export const GlobalContexProvider = ({ children }) => {
  return REGISTERED_CONTEXTS.reduce(
    (ctxChain, ctx) => (ctxChain = ctxChain ? ctx(ctxChain) : ctx(children)),
    ''
  );
};

export default GlobalContex;
export const AccountContext = Account.context;
export const AppContext = App.context;
export const WidgetsContext = Widgets.context;
export const ModalContext = Modal.context;
export const PlansContext = Plans.context;
